// Edit class locations and schedules here. Times are Pacific Time.
export const CLASS_TIMEZONE = "PT";

export const CLASS_LOCATIONS = [
  {
    id: "equinox-san-diego",
    name: "Equinox San Diego",
    detail: "Downtown",
    address: "950 Waterfront Pl, Suite 159, San Diego, CA 92101",
    schedule: [
      { day: "Mon", time: "12:30 PM", className: "Power Yoga Flow" },
      { day: "Wed", time: "9:30 AM", className: "Vinyasa Yoga Flow" },
      { day: "Thu", time: "7:45 AM", className: "Heated Yoga Flow" },
      { day: "Thu", time: "11:15 AM", className: "Vinyasa Yoga Flow" },
    ],
  },
  {
    id: "equinox-la-costa",
    name: "Equinox La Costa",
    detail: "Carlsbad",
    address: "7710 El Camino Real, Carlsbad, CA 92009",
    schedule: [{ day: "Tue", time: "4:00 PM", className: "Power Yoga Flow" }],
  },
  {
    id: "sojourn",
    name: "Sojourn Healing Collective",
    detail: "San Diego",
    address: "811 25th St, Suite 102, San Diego, CA 92102",
    schedule: [
      { day: "Wed", time: "4:00 PM", className: "Breathwork" },
      { day: "Wed", time: "5:30 PM", className: "Power Yoga Flow" },
    ],
  },
];

export const directionsUrl = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
